import { oz } from '@weft/utils';
import { HubspotIntegrationSettingsSchema } from './hubspot';
import { NetSuiteIntegrationSettingsSchema } from './net-suite';
import { StripeIntegrationSettingsSchema } from './stripe';

export const IntegrationSettingsSchema = oz.discriminatedUnion('integrationProvider', [
  NetSuiteIntegrationSettingsSchema,
  HubspotIntegrationSettingsSchema,
  StripeIntegrationSettingsSchema,
]).openapi('IntegrationSettings');

export type IntegrationSettings = oz.infer<typeof IntegrationSettingsSchema>;